export const PARTNER_SETTINGS_CONSTANTS = {
  HAS_GLOBAL_ROUND: 'hasGlobalRound',
  HAS_LEAGUE_STATISTIC: 'hasLeagueStatistic',
  HAS_MATCHES_STATISTIC: 'hasMatchesStatistic',
  HAS_SOCIAL_SHARING: 'hasSocialSharing',
  HAS_X2_MODE: 'hasX2Mode',
  USES_LOGO_IMAGES: 'usesLogoImages',
};
